export interface TransferWithdrawalReceipt {
  transferWithdrawalReceipt: TransferWithdrawalResponse;
}

export interface TransferWithdrawalResponse {
  transactionId?: string;
  statusBarStages: StatusBarStages;
  summary: SummaryDetails;
  movementDetails: MovementDetails | null;
  footer: TransferFooterMessage | null;
}

export interface TransferFooterMessage {
  content: string;
  helpContact: string | null;
}

export interface StatusBarStages {
  selectedStage: number;
  stages: TransactionStage[];
  style: string;
}

export interface TransactionStage {
  title: string;
  subtitle: string | null;
}

export interface SummaryDetails {
  title: string;
  rows: SummaryDetailsRow[];
}

export interface SummaryDetailsRow {
  title: string;
  description?: string;
  style: string;
}

export interface MovementDetails {
  title: string;
  products: MovementProductsDetails[];
}

export interface MovementProductsDetails {
  rows: MovementDetailsRow[];
  title: string;
}

export interface MovementDetailsRow {
  title: string;
  description?: string;
  style: string;
}

export enum EMovementDetailStyle {
  Bold = 'bold',
  Regular = 'regular'
}

export enum EStatusBarStyle {
  Canceled = 'canceled',
  Regular = 'regular'
}
